/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1CoachBalance } from './V1CoachBalance'
import {
    V1CoachBalanceFromJSON,
    V1CoachBalanceFromJSONTyped,
    V1CoachBalanceToJSON,
    V1CoachBalanceToJSONTyped
} from './V1CoachBalance'

/**
 *
 * @export
 * @interface V1CoachBalances
 */
export interface V1CoachBalances {
    /**
     *
     */
    items: Array<V1CoachBalance>
}

/**
 * Check if a given object implements the V1CoachBalances interface.
 */
export function instanceOfV1CoachBalances(
    value: object
): value is V1CoachBalances {
    if (!('items' in value) || value['items'] === undefined) return false
    return true
}

export function V1CoachBalancesFromJSON(json: any): V1CoachBalances {
    return V1CoachBalancesFromJSONTyped(json, false)
}

export function V1CoachBalancesFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachBalances {
    if (json == null) {
        return json
    }
    return {
        items: (json['items'] as Array<any>).map(V1CoachBalanceFromJSON)
    }
}

export function V1CoachBalancesToJSON(json: any): V1CoachBalances {
    return V1CoachBalancesToJSONTyped(json, false)
}

export function V1CoachBalancesToJSONTyped(
    value?: V1CoachBalances | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items: (value['items'] as Array<any>).map(V1CoachBalanceToJSON)
    }
}
